import { FiInbox } from "react-icons/fi";

export default function EmptyState({ icon: Icon = FiInbox, title, text, action, compact = false }) {
  return (
    <div className={`empty-state ${compact ? "is-compact" : ""}`}>
      <span className="empty-icon" aria-hidden="true"><Icon size={compact ? 20 : 26} /></span>
      {title && <p className="empty-title">{title}</p>}
      {text && <p className="empty-text">{text}</p>}
      {action && <div className="empty-action">{action}</div>}
    </div>
  );
}
